import { CheckCircle2 } from 'lucide-react';

const LIVE_FEED = [
  { city: 'Auckland', product: 'Aashirvaad Atta 5kg', border: 'border-green-500', delay: '0s' },
  { city: 'Sydney', product: 'Amul Butter 500g', border: 'border-blue-500', delay: '0.5s' },
  { city: 'Brisbane', product: 'MDH Chana Masala', border: 'border-orange-500', delay: '1s' },
];

const PROOFS = [
  { strong: '50,000+ active consumers', rest: ' ordering every week' },
  { strong: 'Live customer base', rest: ' across major Australian & New Zealand cities' },
  { strong: 'Direct-to-consumer distribution', rest: ' via app + retail' },
  { strong: '500+ retail touchpoints', rest: ' across ANZ' },
];

export const ConsumerReach = () => (
  <section className="py-20 md:py-32 bg-white">
    <div className="container mx-auto px-6">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Powered by Real Consumer Reach</h2>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl glow-border">
              <img
                src="https://customer-assets.emergentagent.com/job_global-market-entry/artifacts/v4e0dwq6_7609ad1a-03b1-44d2-b6a6-cbe31bd9fa86.jpeg"
                alt="Box of India App - One App, Two Countries, India Delivered"
                className="w-full h-auto"
              />
            </div>

            <div className="absolute -right-4 top-1/4 space-y-3">
              {LIVE_FEED.map((f) => (
                <div key={f.city} className={`bg-white rounded-lg shadow-xl p-4 border-l-4 ${f.border} animate-pulse`} style={{ animationDelay: f.delay }}>
                  <div className="flex items-center space-x-2 text-sm">
                    <span className="text-2xl">🛒</span>
                    <div>
                      <p className="font-semibold text-gray-900">{f.city}</p>
                      <p className="text-gray-600 text-xs">{f.product}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="absolute -bottom-6 -left-6 bg-[#004aad] text-white px-6 py-4 rounded-xl shadow-xl">
              <div className="text-3xl font-bold">50K+</div>
              <div className="text-sm">Active Users</div>
            </div>
          </div>

          <div className="space-y-6">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
              Built on Real Consumer Demand Across Australia & New Zealand
            </h3>
            <p className="text-lg text-gray-600 leading-relaxed">
              Atlas is powered by the <strong className="text-[#004aad]">Box of India ecosystem</strong> — a live consumer platform operating across ANZ with real customers, real orders, and real product demand.
            </p>

            <ul className="space-y-4">
              {PROOFS.map((p) => (
                <li key={p.strong} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 mt-1">
                    <CheckCircle2 className="h-6 w-6 text-[#004aad]" />
                  </div>
                  <span className="text-gray-700 text-lg">
                    <strong className="text-gray-900">{p.strong}</strong>{p.rest}
                  </span>
                </li>
              ))}
            </ul>

            <div className="pt-4">
              <p className="text-base text-gray-500 italic">
                This isn't just distribution — it's access to a proven, operating consumer ecosystem.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
